/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const cs_discount_codes_code_copied = /** @type {(inputs: {}) => string} */ () => {
	return `Kód zkopírován!`
};

const da_discount_codes_code_copied = /** @type {(inputs: {}) => string} */ () => {
	return `Kode kopieret!`
};

const de_discount_codes_code_copied = /** @type {(inputs: {}) => string} */ () => {
	return `Code kopiert!`
};

const en_discount_codes_code_copied = /** @type {(inputs: {}) => string} */ () => {
	return `Code copied!`
};

const es_discount_codes_code_copied = /** @type {(inputs: {}) => string} */ () => {
	return `¡Código copiado!`
};

const fr_discount_codes_code_copied = /** @type {(inputs: {}) => string} */ () => {
	return `Code copié !`
};

const hu_discount_codes_code_copied = /** @type {(inputs: {}) => string} */ () => {
	return `Kód másolva!`
};

const it_discount_codes_code_copied = /** @type {(inputs: {}) => string} */ () => {
	return `Codice copiato!`
};

const nl_discount_codes_code_copied = /** @type {(inputs: {}) => string} */ () => {
	return `Code gekopieerd!`
};

const pl_discount_codes_code_copied = /** @type {(inputs: {}) => string} */ () => {
	return `Kod skopiowany!`
};

const pt_discount_codes_code_copied = /** @type {(inputs: {}) => string} */ () => {
	return `Código copiado!`
};

const sv_discount_codes_code_copied = /** @type {(inputs: {}) => string} */ () => {
	return `Kod kopierad!`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "cs" | "da" | "de" | "en" | "es" | "fr" | "hu" | "it" | "nl" | "pl" | "pt" | "sv" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const discount_codes_code_copied = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.discount_codes_code_copied(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("discount_codes_code_copied", locale)
	if (locale === "cs") return cs_discount_codes_code_copied(inputs)
	if (locale === "da") return da_discount_codes_code_copied(inputs)
	if (locale === "de") return de_discount_codes_code_copied(inputs)
	if (locale === "en") return en_discount_codes_code_copied(inputs)
	if (locale === "es") return es_discount_codes_code_copied(inputs)
	if (locale === "fr") return fr_discount_codes_code_copied(inputs)
	if (locale === "hu") return hu_discount_codes_code_copied(inputs)
	if (locale === "it") return it_discount_codes_code_copied(inputs)
	if (locale === "nl") return nl_discount_codes_code_copied(inputs)
	if (locale === "pl") return pl_discount_codes_code_copied(inputs)
	if (locale === "pt") return pt_discount_codes_code_copied(inputs)
	return sv_discount_codes_code_copied(inputs)
};
export { discount_codes_code_copied as "discount_codes.code_copied" }